import React from 'react';
import {
  AnyAssetApplication,
  AssetParams,
  FormInputType,
  Grid,
  useAssetConfig,
  useAssetParams,
  useCustodianQuery,
} from '@mss/mss-component-library';
import CustomFields from '../../../asset/components/CustomFields';
import { useCustomFieldsQuery } from '../../../asset/services/queries';
import { assetModel, paramsToExportAssetType } from '../Import/util';
import { filterOption } from '../../util/filterOption';
import { inputTypeComponent, mapInputToJSX } from '../utils/mapInputToJSX';
import CopyButton from '../Import/CopyButton';
import { enterNextStep } from './inputUtil';

type Props = {
  index?: number;
  disabled?: boolean;
  overrideAssetParams?: Partial<AssetParams>;
};

function SettingsForm<AssetType extends AnyAssetApplication>({
  index = 0,
  disabled,
  overrideAssetParams,
}: Props) {
  const { assetType, assetSubType } = useAssetParams(overrideAssetParams);
  const { matchingConfig } = useAssetConfig<AssetType>(assetSubType);
  const { data: customFields, isLoading: isLoadingCustomFields } =
    useCustomFieldsQuery(assetModel[paramsToExportAssetType(assetType)]);
  const { data: custodians, isLoading: isLoadingCustodians } =
    useCustodianQuery();

  const descriptionField = matchingConfig.form.configure.inputs.find(
    x => x.fieldName === 'description'
  );
  const DescriptionField = descriptionField
    ? inputTypeComponent[descriptionField.type as FormInputType]
    : () => null;

  const shouldSetSubType = assetType === 'network' && !!overrideAssetParams;

  return (
    <>
      <Grid.Row>
        {matchingConfig.form.configure.inputs.map(input =>
          mapInputToJSX({
            index,
            disabled,
            fieldNamesToIgnore: ['description'],
            copyButton: true,
            subType:
              shouldSetSubType && ['brand', 'series'].includes(input.fieldName)
                ? { key: 'network_type', value: assetSubType }
                : undefined,
          })(input)
        )}
        <CustomFields
          data={customFields}
          formIndex={index}
          disabled={(isLoadingCustomFields && isLoadingCustodians) || disabled}
          isLoading={isLoadingCustomFields || isLoadingCustodians}
          enterNextStep={enterNextStep(() => true, false)}
          filterOption={filterOption}
          users={custodians}
          createActions={(fieldName, isCustomField) => (
            <CopyButton
              fieldName={fieldName}
              isCustomField={isCustomField}
              index={index}
            />
          )}
        />

        <DescriptionField
          copyButton
          disabled={disabled}
          {...descriptionField}
          index={index}
        />
      </Grid.Row>
    </>
  );
}

export default SettingsForm;
